<template>
    <div class="page_">
        <navbar/>
        <div class="breadcrum_">首页 > 联系我们</div>
        <div class="con_">

          <div class="item_" v-for="item in locList">
            <p>{{item.tit}}</p>
            <p>{{item.address}}</p>
            <p>电话：{{item.phone}}</p>
          </div>
        </div>
        <footbar></footbar>
    </div>
</template>
<style lang="scss" scoped>
.page_ {
    font-size: 12px;
    .con_{
      width:1000px;
      margin:20px auto;
      padding:30px 30px;
      display:flex;
      flex-wrap:wrap;
      border-top:1px solid #f2f2f2;
      border-bottom:1px solid #f2f2f2;
      .item_{
        margin-bottom:20px;
        width:50%;
        // flex:1;
        p{
          margin:0;
          font-size:14px;
          line-height:25px;
          &:first-child{
            font-weight:bold;
            font-size:18px;
          }
        }
      }
    }
    .breadcrum_ {
        font-size: 12px;
        color: #666666;
        width:1000px;
        margin: 34px auto 24px;
    }
}
</style>
<script>
import navbar from './components/navbar'
import footbar from './components/footbar'
import api from '@/utils/api'
export default {
    data () {
        document.title = '联系我们'
        return {
          locList:[
            {
              tit:'总部',
              address:'上海市浦东新区福山路500号城建国际中心25层01-04单元',
              phone:'021-38295888'
            },
            {
              tit:'上海分公司',
              address:'上海市浦东新区浦电路577号平安财富大厦裙楼308单元',
              phone:'021-38295957'
            },
            {
              tit:'上海自贸试验区分公司',
              address:'上海市浦东新区福山路500号城建国际中心25层05单元',
              phone:'021-38295888'
            },
            {
              tit:'浙江分公司',
              address:'浙江省杭州市下城区环城北路208号（坤和中心）1004室',
              phone:'0571-85155257'
            },
            {
              tit:'江苏分公司',
              address:'江苏省南京市建邺区庐山路188号新地中心一期1012室',
              phone:'025-66006135'
            },
            {
              tit:'苏州分公司',
              address:'江苏省苏州市工业园区苏州大道西205号尼盛广场1107室',
              phone:'0512-65221888 0512-65242234'
            },
            {
              tit:'宁波分公司',
              address:'浙江省宁波市江东区河清北路369号（新府银座）603室',
              phone:'0574-87011016'
            },
            {
              tit:'安徽分公司',
              address:'安徽省合肥市濉溪路116号信达大厦8层',
              phone:'0551-62851300'
            },
            {
              tit:'青岛分公司',
              address:'山东省青岛市香港中路9号香格里拉中心（办公楼）2501室',
              phone:'0532-89071306'
            },
            {
              tit:'福建分公司',
              address:'福建省福州市鼓楼区吉田路60号福晟财富中心12层1202单元',
              phone:'0591-63515501'
            },
            {
              tit:'北京分公司',
              address:'北京市朝阳区永安东里16号CBD国际大厦17层09、10单元',
              phone:'010-65664800'
            },
            {
              tit:'广东分公司',
              address:'广东省广东市珠江新城珠江东路28号（越秀金融大厦）2709-2710室',
              phone:'020-61846022'
            },
            {
              tit:'重庆分公司',
              address:'重庆市渝中区解放碑民族路188号环球金融中心20层5-2单元',
              phone:'023-81157200'
            },
            {
              tit:'湖北分公司',
              address:'湖北省武汉市武昌区中北路9号长城汇T2好写字楼第29层R1单元',
              phone:'027-59515905'
            },
          ]
        }   
    },
    components: {
        navbar,
        footbar
    },
    mounted () {
       
    },
    methods: {
    }
}
</script>